import React, { useState } from "react"
import MatchCompany from "../components/MatchCompany/MatchCompany"
import { motion } from "framer-motion"
import { getPrefersDarkMode } from "../hooks/setThemeColor"

const MatchGame = () => {
    const themeColor = getPrefersDarkMode() ? "#171717" : "#ffffff"
    const [background, setBackground] = useState(themeColor)
    const [initial, setInitial] = useState(true)

    const handleBackgroundChange = (newBackground) => {
        setBackground(newBackground)
    }

    const handleInitialChange = (value) => {
        setInitial(value)
    }

    return (
        <motion.div
            className="fixed top-0 left-0 right-0 bottom-0 w-full overflow-hidden"
            style={{
                background: initial ? themeColor : background,
                transition: "background 0.3s ease",
            }}
        >
            <MatchCompany
                onBackgroundChange={handleBackgroundChange}
                onInitialChange={handleInitialChange}
                parentBackground={background}
                themeColor={themeColor}
            />
        </motion.div>
    )
}

export default MatchGame
